module.exports = __webpack_public_path__ + "static/media/handSanitizer.ed284031.svg";